<template>
  <v-dialog v-model="openModal" width="535px" persistent>
    <v-card>
      <v-card-text class="d-grid pb-1">
        <div
          class="feedback-warning-background my-6"
          style="
            padding: 16px;
            border-radius: 100px;
            width: 80px;
            height: 80px;
            display: flex;
            align-items: center;
          "
        >
          <simple-svg
            :src="require('@/assets/panda-bandwidth-feedback-warning.svg')"
            fill-class-name="fill-color"
            :fill="'var(--feedback-warning)'"
            width="48px"
          />
        </div>
        <span class="body-bold-medium neutral-20-dark--text mb-6">{{
          $t('message.warningDownload.title')
        }}</span>
        <span class="body-regular-small neutral-40-light--text mb-3">{{
          $t('message.warningDownload.bandwidthNotice')
        }}</span>
        <span class="body-regular-small neutral-40-light--text my-2">{{
          $t('message.warningDownload.confirmationPrompt')
        }}</span>
        <a
          :href="$t('message.warningDownload.href')"
          type="secondary"
          target="_blank"
          size="xsmall"
          class="mb-4"
          >{{ $t('message.warningDownload.learnMore') }}
          <v-icon size="12px" class="body-bold-smaller">
            mdi-open-in-new
          </v-icon></a
        >
        <div class="d-flex align-center">
          <v-checkbox v-model="valid"></v-checkbox>
          <span
            class="body-regular-bold-small neutral-40-light--text"
            style="margin-bottom: 10px"
          >
            {{ $t('message.warningDownload.checkboxLabel') }}
          </span>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions class="px-6 py-6">
        <v-spacer></v-spacer>
        <base-btn type="tertiary" text class="mr-4 px-4" @click="handleClose">
          {{ $t('message.cancel') }}
        </base-btn>
        <v-tooltip v-if="!valid" bottom>
          <template v-slot:activator="{ on, attrs }">
            <base-btn
              type="primary"
              large
              min-width="185px"
              @click="confirm"
              :disabled="!valid"
              v-bind="attrs"
              v-on="on"
            >
              {{ $t('message.confirm') }}
            </base-btn>
          </template>
          <v-container class="text-body-2 pa-0" style="max-width: 230px">
            {{ $t('message.warningDownload.tooltipConfirm') }}
          </v-container>
        </v-tooltip>
        <base-btn
          v-else
          type="primary"
          large
          min-width="185px"
          @click="confirm"
          :disabled="!valid"
        >
          {{ $t('message.confirm') }}
        </base-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'WarningDownloadModal',
  data() {
    return {
      openModal: null,
      openDownloadVideoModal: false,
      valid: false,
    }
  },
  props: {
    openWarningDownload: {
      type: Boolean,
      default: false,
    },
    videoName: {
      type: String,
      default: '',
    },
    videoId: {
      type: String,
      default: '',
    },
    originalLang: {
      type: String,
      default: '',
    },
    availableAudios: {
      type: Array,
    },
    availableVideoQualities: {
      type: Array,
    },
    downloadLoadingStatus: {
      type: Boolean,
      default: false,
    },
    storageSizeDetails: {
      type: Object,
    },
    notCloseModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
      userInfo: (state) => state.user.userInfo,
    }),
  },
  watch: {
    openWarningDownload(val) {
      this.openModal = val
    },
  },
  methods: {
    handleClose() {
      if (!this.notCloseModal) this.$root.$emit('closeDownloadVideoModal')
      this.$root.$emit('closeWarningDownload')
      this.openModal = false
    },
    confirm() {
      this.handleClose()
      localStorage.setItem(`isUnderstandDownload-${this.userInfo.sub}`, true)

      if (this.videoName && !this.notCloseModal) {
        this.$root.$emit('openModalDownloadVideo')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.d-grid {
  display: grid;
  justify-items: start;
}
</style>
